import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, numeric } from 'vee-validate/dist/rules.umd.js';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

extend('required', {
  ...required,
  message: 'Field is required'
})

extend('email', {
  ...email,
  message: 'Email is not valid'
})

extend('numeric', {
  ...numeric,
  message: 'Numbers only expected'
})

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Password confirmation does not match'
})

extend('min-password', {
  validate(value) {
    return value.length >= 6;
  },
  message: 'Password must contain at least 6 characters'
});

extend('min-length', {
  params: ['length'],

  validate(value, { length }) {
    if (!value) return true;
    if (!length) return true;
    return String(value).length >= Number(length);
  },

  message: 'Field must contain at least {length} characters'
});

extend("postal", {
  params: ["country"],

  validate: (value, { country }) => {
    if (!value) return false;

    const cleanValue = value.trim().toUpperCase();
    const cleanCountryValue = country?.toLowerCase();

    const canadaRegex = /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/;
    const usaRegex = /^\d{5}(-?\d{4})?$/;

    if (cleanCountryValue === "canada") {
      return canadaRegex.test(cleanValue);
    } else if (cleanCountryValue === "usa") {
      return usaRegex.test(cleanValue);
    } else {
      return true;
    }
  },

  message: (field, { country }) => {
    if (country === "Canada") {
      return "Please enter a valid Canadian postal code";
    } else if (country === "USA") {
      return "Please enter a valid US ZIP code";
    } else {
      return "Please enter a valid postal code";
    }
  },
});